import { theme, css } from '../lib';

type Space = keyof typeof theme.space;

export const centerTo = {
  x: css`
    left: 50%;
    position: absolute;
    transform: translate3d(-50%, 0, 0);
  `,

  y: css`
    position: absolute;
    top: 50%;
    transform: translate3d(0, -50%, 0);
  `,

  both: css`
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  `,
};

export const flex = {
  center: css`
    align-items: center;
    display: flex;
    justify-content: center;
  `,
};

export const lineClamp = (lines: number) => css`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lines};
  display: -webkit-box;
  overflow: hidden;
`;

export const margin = {
  auto: css`
    margin: 0 auto;
  `,

  bottom: (space: Space) => css`
    margin-bottom: ${theme.space[space]};
  `,

  left: (space: Space) => css`
    margin-left: ${theme.space[space]};
  `,

  right: (space: Space) => css`
    margin-right: ${theme.space[space]};
  `,

  top: (space: Space) => css`
    margin-top: ${theme.space[space]};
  `,
};

export const padding = {
  bottom: (space: Space) => css`
    padding-bottom: ${theme.space[space]};
  `,

  left: (space: Space) => css`
    padding-left: ${theme.space[space]};
  `,

  right: (space: Space) => css`
    padding-right: ${theme.space[space]};
  `,

  top: (space: Space) => css`
    padding-top: ${theme.space[space]};
  `,
};

export const positionFixed = css`
  backface-visibility: hidden;
  position: fixed;
  transform: translate3d(0, 0, 0);
`;

export const positionSticky = css`
  backface-visibility: hidden;
  position: sticky;
  transform: translate3d(0, 0, 0);
`;

export const fixedTo = {
  bottom: css`
    ${positionFixed};
    bottom: 0;
    left: 0;
    right: 0;
  `,

  left: css`
    ${positionFixed};
    bottom: 0;
    left: 0;
    top: 0;
  `,

  right: css`
    ${positionFixed};
    bottom: 0;
    right: 0;
    top: 0;
  `,

  top: css`
    ${positionFixed};
    left: 0;
    right: 0;
    top: 0;
  `,

  screen: css`
    ${positionFixed};
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  `,
};

export const stickyTo = {
  top: css`
    ${positionSticky};
    top: 0;
    right: 0;
    left: 0;
  `,
};

export const position = {
  fixedTo,
  stickyTo,
};

export const shadowContrast = '2px 0px 0px rgba(0, 0, 0, 0.7)';
